import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {toastr} from 'react-redux-toastr';
import SettingsForm from "./SettingsForm";
import SettingsList from "./SettingsList";
import * as settingsActions from "../../actions/settingsActions";
import * as submitButtonActions from '../../actions/submit/submitButtonActions';
import SettingsFormSerializer from "../../services/SettingsFormSerializer";

class SettingsFormContainer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.submit = this.submit.bind(this);
    }


    componentDidMount() {
        this.props.actions.getSettings();
    }

    submit(params) {
        this.props.actions.showSubmitButtonSpinner();
        let formData = SettingsFormSerializer.serialize(params);
        this.props.actions.updateSettings(formData.key, formData).then(() => {
            toastr.success('Indstillinger er opdateret');
            this.props.actions.hideSubmitButtonSpinner();
        });
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-6">
                    <div className="card m-b-20">
                        <div className="card-block">
                            <h1 className="mb-3">Indstillinger</h1>
                                <SettingsList
                                    settings={this.props.settings}
                                />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card m-b-20">
                        <div className="card-block">
                            <h1 className="mb-3">Tilføj valgmulighed</h1>
                            <SettingsForm
                                settings={this.props.settings}
                                onSubmit={this.submit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let settings    = state.settings;
    settings        = SettingsFormSerializer.unserialize(settings);

    return {
        settings: settings,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...settingsActions,
            ...submitButtonActions
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsFormContainer);


// WEBPACK FOOTER //
// ./web/src/components/settings/SettingsFormContainer.jsx